import accounting from 'accounting';

function currencyFilter(CompanyStoreService, $translate) {
    'ngInject';

    return (amount, currency_code, pretty_price) => {

        if (pretty_price == null) {
            pretty_price = false;
        }
        if (!angular.isNumber(amount)) {
            return;
        }

        const currency_codes = {USD: '$', GBP: '£', AUD: '$', EUR: '€', CAD: '$', MIXED: '~', RUB: '₽'};

        if (!currency_code) {
            ({currency_code} = CompanyStoreService);
        }

        const format = $translate.instant(['CORE.FILTERS.CURRENCY.THOUSANDS_SEPARATOR', 'CORE.FILTERS.CURRENCY.DECIMAL_SEPARATOR', 'CORE.FILTERS.CURRENCY.CURRENCY_FORMAT']);

        const hide_decimal = pretty_price && ((amount % 100) === 0);
        const decimal_places = hide_decimal ? 0 : 2;

        return accounting.formatMoney(amount / 100, currency_codes[currency_code], decimal_places, format.THOUSANDS_SEPARATOR, format.DECIMAL_SEPARATORS, format.CURRENCY_FORMAT);
    };
}

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats price using either the configured Company currency or the provided currency symbol.
 *
 * @param {integer} amount Input amount to format
 * @param {string} currency_code Optional currency symbol
 * @param {boolean} pretty_price Use to omit decimal places when price is whole. Default is false
 * @returns {string} Formatted currency.
 *
 *
 <example module="currencyExample">
 <file name="index.html">
 <script>
 angular.module('currencyExample', [])
 .controller('ExampleController', ['$scope', function($scope) {
 $scope.price = 950;
 }]);
 </script>
 <div ng-controller="ExampleController">
 <span>Price: {{price | currency}}</span><br/>
 </div>
 </file>
 </example>
 */
angular
    .module('BB')
    .filter('currency', currencyFilter);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/currency.filter.js